import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import * as api from '../../api';

export function* getMasterCourse({ masterCourseId, version }) {
    const payload = yield call(api.getMasterCourse, masterCourseId, version);
    if (payload.status === 200) {
        yield put(actions.getMasterCourseSuccess(payload.data));
    } else {
        yield put(actions.getMasterCourseFailure());
    }
}

export function* getMasterCourseSaga() {
    yield takeLatest(actions.GET_MASTER_COURSE_REQUEST, getMasterCourse);
}


export function* saveCourse({ request }) {
    const payload = yield call(api.saveDefaultCourse, request);
    if (payload.status === 200) {
        yield put(actions.saveCourseSuccess(payload.data));
    } else if (payload.status === 400 || payload.status === 409) {
        yield put(actions.saveCourseValidationError(payload.message));
    } else {
        yield put(actions.saveCourseFailure());
    }
}

export function* saveCourseSaga() {
    yield takeLatest(actions.SAVE_COURSE_REQUEST, saveCourse);
}

export function* publishCourse({ courseId, productId, context }) {
    const payload = yield call(api.publishDefaultCourse, { courseId, productId });
    if (payload.status === 200) {
        yield put(actions.publishCourseSuccess(context));
    } else {
        yield put(actions.publishCourseFailure());
    }
}

export function* publishCourseSaga() {
    yield takeLatest(actions.PUBLISH_COURSE_REQUEST, publishCourse);
}

export function* getDefaultCourse({
    productId,
    courseId,
    version,
    switchToMasterCourseId,
    switchToMasterCourseVersion
}) {
    const payload = yield call(api.getDefaultCourse, {
        productId,
        courseId,
        version,
        switchToMasterCourseId,
        switchToMasterCourseVersion
    });
    if (payload.status === 200) {
        yield put(actions.getDefaultCourseSuccess(payload.data));
    } else {
        yield put(actions.getDefaultCourseFailure());
    }
}

export function* getDefaultCourseSaga() {
    yield takeLatest(actions.GET_DEFAULT_COURSE_REQUEST, getDefaultCourse);
}




// WEBPACK FOOTER //
// ./app/containers/course-creator/saga.js